import React from 'react'
import useRedirectParam from '@vero/ui-core-browser/hooks/redirect-param.js'
import Page from '@vero/ui-components/pages/page.jsx'
import Redirecting from '@vero/ui-components/components/redirecting.jsx'
import PageHeader from '@vero/ui-components/components/page-header.jsx'
import DrawerPage from '@vero/ui-components/pages/drawer-page.jsx'
import useClaims from '../hooks/claims.js'
import Company from '../widgets/company.jsx'
import DrawerMenu from '../widgets/drawer-menu.jsx'

export default function ({ title, children }) {
  const { claims, isLoggedIn } = useClaims()
  const { redirect } = useRedirectParam(window.location.pathname)

  if (!isLoggedIn()) {
    window.location.href = `/auth/login?r=${redirect}`

    return (
      <Page title={title}>
        <Redirecting />
      </Page>
    )
  }

  return (
    <DrawerPage
      title={title}
      menu={<DrawerMenu />}
    >
      <PageHeader className='fixed z-40' claims={claims}>
        <Company />
      </PageHeader>

      <div className='mt-16 md:mt-20'>
        {children}
      </div>
    </DrawerPage>
  )
}
